import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
// modals.
import { DialogTitle, DialogActions, DialogContent } from "../../../Modal/ModalStructure";
// validacion de formulario.
import { Formik } from "formik";
// services / interfaces
import { UserI, addNewUser, UserFromFsI, editCurrentUser } from "../../../../services/usersService";
// schemas.
import { validationSchemaCreate, validationSchemaEdit } from "./validationSchemas";

type Props = {
  open: boolean;
  setOpen: Function;
  addNewProject: Function;
  updateUserList: Function;
  editUser?: UserFromFsI;
  createMode: boolean;
};

const AddUserModal: React.FC<Props> = ({ open, setOpen, addNewProject, updateUserList,  editUser, createMode }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    if (!isLoading) {
      setError('');
      setOpen(false);
    }
  }

  const formValues: UserI = {
    userEmail: !createMode ? editUser?.USER_EMAIL || "" : "",
    userPassword: "",
    userRole: "",
  };

  return (
    <Dialog
      aria-labelledby="modal-pryecto"
      maxWidth="sm"
      fullWidth={true}
      open={open}
    >
      { isLoading && <LinearProgress />}
      <Formik
        initialValues={formValues}
        validationSchema={createMode ? validationSchemaCreate : validationSchemaEdit }
        onSubmit={async (values, { resetForm }) => {
          setIsLoading(true);

          if(createMode){
            const data = await addNewUser(values);
            if(data.ok){
              setIsLoading(false);
              addNewProject(data.user);
              resetForm();
              handleClose();
            }else{
              setIsLoading(false);
              setError(data.error);
            }
          }else{
            const idUserToUpdate = editUser?.id || "";
            const data = await editCurrentUser(values, idUserToUpdate);
            if(data.ok){
              setIsLoading(false);
              updateUserList(data.user);
              resetForm();
              handleClose();
            }else{
              setIsLoading(false);
              setError(data.error.message);
            }
          }

        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogTitle id="modal-pryecto" onClose={handleClose}>
              { createMode ? 'Añadir usuario' : 'Editar usuario' }
            </DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={2}>
                { error && (
                  <Grid item xs={12} >
                    <Alert severity="error">{ error }</Alert>
                  </Grid>
                )}

                <Grid item xs={12} >
                  <TextField
                    required
                    fullWidth
                    name="userEmail"
                    variant="outlined"
                    label="Correo electronico"
                    autoComplete="off"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.userEmail}
                    error={touched.userEmail && Boolean(errors.userEmail)}
                    helperText={touched.userEmail && errors.userEmail}
                  />
                </Grid>
                {createMode && (
                  <Grid item xs={12} >
                    <TextField
                      required
                      fullWidth
                      name="userPassword"
                      variant="outlined"
                      label="Contraseña"
                      autoComplete="off"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.userPassword}
                      error={touched.userPassword && Boolean(errors.userPassword)}
                      helperText={touched.userPassword && errors.userPassword}
                    />
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={isLoading}
              >
                {createMode ? 'Guardar' : 'Actualizar'}
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddUserModal;